<template>
<div>
	<template v-if="theme == 2">
		<div @click="imgClick()">
			<div :style="'background: url('+realSrc+') center center / cover no-repeat;height:100%'"></div>
		</div>
	</template>
	<template v-else>
		<img class="cmui-img"
		     :src="realSrc"
		     :height="height"
		     :width="width"
		     alt=""
		     @click="imgClick()"
		     @error="error"/>
	</template>
</div>
</template>
<script>
import $ from 'jquery';
import imageLazyLoad from './imageLazyLoad';
var preViewVMList={}
	;

export default {
        props:{
            src:{type:String},
            lazyLoad:{type:Boolean,default:false},
            preView:{type:Boolean,default:false},
            preViewList:{type:Array,default:[]},
            preViewIndex:{type:Number,default:0},
            width: {
            	type: Number

            }
            , height: {
            	type: Number
            }
            , errorSrc: {
                type: String
                , default: ''
            }
            ,
            target: {type:Object},
            theme: {type:Number,default:''}
        },
        computed:{
            realSrc:function(){
                if(this.lazyLoad){
                    return 'http://img.zcool.cn/community/01443f564897a432f87512f6eed753.gif';
                }else{
                    return this.src;
                }
            }
        },
        ready:function(){
            imageLazyLoad.call(this)
        },
        methods:{
            imgClick:function(){
                var _this=this;
                if(this.preView){
                    var preViewTpl='';
                    var preViewTplId='preView_'+(Math.random()*1000|0);
                    // todo z-index 是为了挡住返回顶部组件的。。。坑
                    preViewTpl+='<div class="fixed-full cmui-imgPreViewSlider" @click="preViewListClick()" id="'+preViewTplId+'" style="z-index:2147483646;background-color: rgba(0, 0, 0, 0.7);">';
                    preViewTpl+='    <cmui-slider :auto="0"  :theme="0" :items="preViewList_temp" :options="options">';
                    preViewTpl+='        <cmui-slider-item v-for="item in preViewList_temp" :loop="preViewList_temp.length>1">';
                    preViewTpl+='            <img :src="item" alt="" @click="preViewListClick()">';
                    preViewTpl+='        </cmui-slider-item>';
                    preViewTpl+='    </cmui-slider>';
                    preViewTpl+='</div>';
                    $('body').append(preViewTpl).css('overflow', 'hidden');
                    var inSlider=this.$parent.constructor.name=='CmuiSliderItem';
                    preViewVMList[preViewTplId]=new Vue({
                        el:'#'+preViewTplId,
                        data:{
                            preViewList_temp:this.preViewList.length?this.preViewList:[this.src],
                            options:{
                                initialSlide:this.preViewIndex
                            }
                        },
                        ready(){
                            _this.$dispatch('preView',true)
                        },
                        methods:{
                            preViewListClick:function(){
                                this.$destroy(true);
                                _this.$dispatch('preView',false)
	                            $('body').css('overflow', 'auto');
                            }
                        }
                    });

                    var $cmuiSlider=$(preViewVMList[preViewTplId].$el).find('>.cmui-slider');
                    $cmuiSlider.css('margin-top',(index,num)=>{
                        return (document.documentElement.clientHeight-$cmuiSlider.height())/2
                    });
                }
            }
            , error(){
            	if( this.src !== this.errorSrc ){   // 防止递归加载 error 图片

		            this.errorSrc && (this.src = this.errorSrc);
                }
            }
        },
        events:{
            pageScroll:function(){
                imageLazyLoad.call(this)
            }
        }
};
</script>
<style lang="scss">
    .cmui-imgPreViewSlider .swiper-wrapper{
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            -ms-flex-pack: justify;
            justify-content: space-between;
    }
</style>
